module.exports = __webpack_public_path__ + "static/media/2.38c614f5.png";